import React, { useEffect, useState, useContext } from 'react';
import axios from 'axios';
import { getBackendUserUrl } from '../../../utils/utils';
import { List, ListItem, ListItemText, CircularProgress, Alert, Dialog, DialogTitle, DialogContent, Button } from '@mui/material';
import { CommonEventContext } from '../../../contexts/EventContext';

const DocumentList = ({ documents }) => {
    const { eventId } = useContext(CommonEventContext);
    const [open, setOpen] = useState(false);
    const [selectedDocument, setSelectedDocument] = useState(null);
    const [fetchedDocuments, setFetchedDocuments] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const handleClickOpen = (doc) => {
        setSelectedDocument(doc);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setSelectedDocument(null);
    };

    const handleDownload = (doc) => {
        const link = document.createElement('a');
        link.href = `data:application/pdf;base64,${doc.content}`;
        link.download = doc.name;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const fetchDocuments = async () => {
        try {
            const response = await axios.get(`${getBackendUserUrl()}/document/get_document_for_event?event_id=${eventId}`);
            console.log('Response from backend:', response.data);
            if (response.data.message) {
                setError(response.data.message);
            } else {
                setFetchedDocuments(response.data);
            }
        } catch (err) {
            console.error('Error fetching documents:', err);
            setError(err.response?.data?.detail || 'Failed to fetch documents');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchDocuments();
    }, [eventId, documents]);

    useEffect(() => {
        if (documents) {
            fetchDocuments();
        }
    }, [documents]);

    if (loading) return <CircularProgress />;
    if (error) return <Alert severity="error">{error}</Alert>;
    if (!loading && fetchedDocuments.length === 0) return <div>No files have been uploaded.</div>;

    return (
        <>
            <List>
                {fetchedDocuments.map((doc, index) => (
                    <ListItem key={index} button onClick={() => handleDownload(doc)}>
                        <ListItemText primary={doc.name} />
                    </ListItem>
                ))}
            </List>
            <Dialog open={open} onClose={handleClose} fullWidth maxWidth="md" disableEscapeKeyDown={false}>
                <DialogTitle>{selectedDocument?.name}</DialogTitle>
                <DialogContent>
                    <Button onClick={() => handleDownload(selectedDocument)}>Download PDF</Button>
                </DialogContent>
            </Dialog>
        </>
    );
};

export default DocumentList; 